var map = {
	"./paper.png": 14,
	"./paper_lose.png": 16,
	"./paper_win.png": 17,
	"./rock.png": 13,
	"./rock_lose.png": 18,
	"./rock_win.png": 19,
	"./scissors.png": 15,
	"./scissors_lose.png": 20,
	"./scissors_win.png": 21
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;